var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrixEvaluation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 31,
    viewBox: "0 0 29 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.01319 15.3736V29.4129C8.01319 30.3237 7.66041 30.6741 6.74126 30.6741H1.19994C0.38758 30.6741 0 30.2937 0 29.4873C0 20.0534 0 10.6195 0 1.18554C0 0.379181 0.38638 0 1.19994 0H6.77005C7.64721 0 8.01199 0.359983 8.01199 1.23114C8.01439 5.9477 8.01479 10.6619 8.01319 15.3736ZM2.03629 2.0231V28.6618H5.9853V2.0231H2.03629Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0066 19.3574V9.23706C20.0066 8.37791 20.3665 8.01072 21.2209 8.00952H26.8198C27.649 8.00952 28.0198 8.38751 28.0198 9.22507C28.0198 15.9711 28.0198 22.718 28.0198 29.4656C28.0198 30.2984 27.6418 30.6788 26.8198 30.68H21.2185C20.3845 30.68 20.0078 30.3068 20.0066 29.48V19.3574ZM25.9835 28.6617V10.035H22.0333V28.6617H25.9835Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.017 23.3723C18.017 25.3978 18.017 27.4233 18.017 29.4488C18.017 30.3164 17.6499 30.68 16.7751 30.68H11.2062C10.3794 30.68 10.0062 30.302 10.0062 29.468V17.2286C10.0062 16.3887 10.3842 16.0095 11.2338 16.0083H16.8015C17.6415 16.0083 18.0182 16.3887 18.0182 17.2394C18.0182 19.2833 18.0178 21.3276 18.017 23.3723ZM12.0401 18.0242V28.6617H15.9819V18.0242H12.0401Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrixEvaluation);
export default __webpack_public_path__ + "static/media/prix_evaluation.5c5e20fde18a09f4274fae6c9cfce5af.svg";
export { ForwardRef as ReactComponent };